import {
  RefObject,
  Dispatch,
  SetStateAction,
  createContext,
  MouseEvent,
} from "react";
import type { OpenCloseTransitionStates } from "../../../internal/hooks/useOpenCloseTransitionStates/useOpenCloseTransitionStates";

export type DialogContextProps = {
  close: (e?: MouseEvent<HTMLElement>) => void;
  ref?: RefObject<HTMLDialogElement>;
  hasOpenPopover?: boolean;
  setHasOpenPopover?: Dispatch<SetStateAction<boolean | undefined>>;
  headerRef?: RefObject<HTMLElement>;
  /**
   * The current transition state of the dialog.
   */
  state?: OpenCloseTransitionStates;
};

export const DialogContext = createContext<DialogContextProps | null>(null);
